import { Typography } from '@mui/material'

export function UIMessageNoRows({ message }: { message: string }) {
  return (
    <Typography mt={2} color="textSecondary" variant="body1">
      {message}
    </Typography>
  )
}
